if (!customElements.get("vt-header-top")) {
  customElements.define(
    "vt-header-top",
    class VTHeaderTop extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.querySelector(".vt-header-top__country-list--select");
        this.querySelector(".vt-header-top__country-list--label");
      }
    }
  );
}
